import { MasterModule } from './master/master.module';
import { SharedModule } from './shared/shared.module';
import { AutenticationModule } from './autentication/autentication.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AutenticationHttpInterceptor } from './autentication/autentication.http.interceptor';
import { ThemeService } from './shared/theme-service/theme.service';
import { DinamicCssComponent } from './dinamic-css/dinamic-css.component';
import { LoadingInterceptorService } from './shared/interceptors/loading-interceptor.service';
import "hammerjs";

@NgModule({
	declarations: [
		AppComponent,
		DinamicCssComponent,
	],
	imports: [
		AppRoutingModule,
		BrowserModule,
		AutenticationModule,
		HttpClientModule,
		MatNativeDateModule,
		BrowserAnimationsModule,
		SharedModule,
		MasterModule
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AutenticationHttpInterceptor,
			multi: true
		},
		{
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptorService,
      multi: true
    },
		{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ThemeService
	],
	bootstrap: [AppComponent]
})
export class AppModule {}

/* fix para propriedades do tweenmax poderem ser passadas inlline no tween,
o TS tava solicitando que fosse uma variável.*/
declare module 'gsap' {
	export interface TweenConfig {
		[p: string]: any;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/app.module.ts